import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { distinctUntilChanged } from 'rxjs/operators';
import { AppLoadingService } from './app-loading.service';

@Component({
  selector: 'eview-global-loader',
  templateUrl: './global-loader.component.html',
  styleUrls: ['./global-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GlobalLoaderComponent {
  private readonly loading = inject(AppLoadingService);
  readonly loading$ = this.loading.loading$.pipe(distinctUntilChanged());
}
